import { render, staticRenderFns } from "./select-integral-type.vue?vue&type=template&id=0b0f3e33"
import script from "./select-integral-type.vue?vue&type=script&lang=ts"
export * from "./select-integral-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports